import { useTable } from 'react-table';

function ResponsiveTable({ columns, data, visibleOnMobile = [], compact: compactProp }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  const compact = compactProp ?? columns.length >= 13;
  const px = compact ? 'px-2' : 'px-3';
  const py = compact ? 'py-2' : 'py-3';
  const textSize = compact ? 'text-xs' : 'text-sm';

  return (
    <div className="overflow-x-auto rounded-2xl border border-white/[0.08]">
      <table
        {...getTableProps()}
        className={`w-full table-auto ${textSize} text-center`}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr key={headerGroup.getHeaderGroupProps().key} className="bg-white/[0.03] border-b border-white/[0.08]">
              {headerGroup.headers.map((column) => {
                const { key, ...rest } = column.getHeaderProps();
                const isMobileVisible = visibleOnMobile.includes(
                  column.id || column.accessor
                );
                return (
                  <th
                    key={key}
                    {...rest}
                    className={`${px} ${py} font-semibold text-slate-400 text-xs uppercase tracking-wide whitespace-nowrap ${
                      isMobileVisible ? '' : 'hidden md:table-cell'
                    }`}>
                    {column.render('Header')}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="bg-transparent divide-y divide-white/[0.05]">
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-12 text-slate-500 text-sm">
                데이터 없음
              </td>
            </tr>
          ) : (
            rows.map((row) => {
              prepareRow(row);
              return (
                <tr key={row.getRowProps().key} className="hover:bg-white/[0.03] transition-colors">
                  {row.cells.map((cell) => {
                    const { key, ...rest } = cell.getCellProps();
                    const isMobileVisible = visibleOnMobile.includes(
                      cell.column.id || cell.column.accessor
                    );
                    return (
                      <td
                        key={key}
                        {...rest}
                        className={`${px} ${py} text-slate-200 whitespace-nowrap ${
                          isMobileVisible ? '' : 'hidden md:table-cell'
                        }`}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ResponsiveTable;
